import { render } from "./Phantoms.vue?vue&type=template&id=2f4ec37a&scoped=true"
import script from "./Phantoms.vue?vue&type=script&lang=js"
export * from "./Phantoms.vue?vue&type=script&lang=js"

import "./css/style.css?vue&type=style&index=0&id=2f4ec37a&scoped=true&lang=css"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4ec37a"]])

export default __exports__